/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetExamPeriodById = require('../services/GetExamPeriodById');
var GetAllLicenseTypes = require('../../common/services/GetAllLicenseTypes');
var GetAllRegions = require('../../common/services/GetAllRegions');

var NonDepInternalIssueExamView = require('../views/NonDepInternalIssueExamView');

module.exports = function(examYearId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetExamPeriodById(examYearId), GetAllLicenseTypes(), GetAllRegions()).done(function(
    examPeriod,
    licenseTypes,
    regions
  ) {
    NavUtils.navigate('nondep/dashboard/exams/' + examYearId + '/issue');
    Scaffold.content.show(
      new NonDepInternalIssueExamView({
        model: new Backbone.Model({
          examYear: examPeriod.yearPeriod,
          examYearId: examPeriod.id,
          licenseTypes: licenseTypes,
          regions: regions
        })
      })
    );
    NProgress.done();
  });
};
